export class SearchSessionApi {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * @returns SearchSession
     * @throws ApiError
     */
    getIndex() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/search-session',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    createSearchSession({ requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/search-session',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns SearchSession
     * @throws ApiError
     */
    get({ id, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/search-session/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    update({ id, requestBody, }) {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/search-session/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    archive({ id, }) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/search-session/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    search({ title, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/search-session/search',
            query: {
                'title': title,
            },
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    delete({ id, }) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/search-session/{id}/delete',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns Project
     * @throws ApiError
     */
    createProject({ id, requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/search-session/{id}/project',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    getState({ id, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/search-session/{id}/project/state',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns Sequence
     * @throws ApiError
     */
    toggleSequence({ id, sequenceId, requestBody, }) {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/search-session/{id}/project/sequence/{sequenceId}/enabled',
            path: {
                'id': id,
                'sequenceId': sequenceId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
